"use client";

import { forwardRef, useRef } from "react";
import driverOne from "./../assets/images/casual-driver-one.jpg";
import driverTwo from "./../assets/images/casual-driver-two.jpg";
import driverThree from "./../assets/images/casual-driver-three.jpg";
import driverFour from "./../assets/images/casual-driver-four.jpg";
import driverFive from "./../assets/images/casual-driver-five.jpg";
import layerPlatform from "./../assets/images/layers-platform-icon.svg";
import rentidLogo from "./../assets/images/rentid-icon-hub.svg";
import clsx from "clsx";
import { AnimatedBeam } from "./animated-beam";
import "./animated-beam-multiple.css";

const Circle = forwardRef(({ className, children }, ref) => {
  return (
    <div
      ref={ref}
      className={clsx("r2-animated-beam-multiple__circle", className)}
    >
      {children}
    </div>
  );
});

Circle.displayName = "Circle";

export function AnimatedBeamMultiple({ className }) {
  const containerRef = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);
  const div3Ref = useRef(null);
  const div4Ref = useRef(null);
  const div5Ref = useRef(null);
  const div6Ref = useRef(null);
  const div7Ref = useRef(null);

  return (
    <div
      className={clsx("r2-animated-beam-multiple", className)}
      ref={containerRef}
    >
      <div className="r2-animated-beam-multiple__layout">
        <div className="r2-animated-beam-multiple__column">
          <Circle ref={div7Ref}>
            <Icons.User />
          </Circle>
        </div>
        <div className="r2-animated-beam-multiple__column">
          <Circle
            ref={div6Ref}
            className="r2-animated-beam-multiple__circle--lg"
          >
            <Icons.Openai />
          </Circle>
        </div>
        <div className="r2-animated-beam-multiple__column r2-animated-beam-multiple__column--stacked">
          <Circle ref={div1Ref}>
            <Icons.GoogleDrive />
          </Circle>
          <Circle ref={div2Ref}>
            <Icons.GoogleDocs />
          </Circle>
          <Circle ref={div3Ref}>
            <Icons.Whatsapp />
          </Circle>
          <Circle ref={div4Ref}>
            <Icons.Messenger />
          </Circle>
          <Circle ref={div5Ref}>
            <Icons.Notion />
          </Circle>
        </div>
      </div>

      {/* AnimatedBeams */}
      <AnimatedBeam
        containerRef={containerRef}
        fromRef={div1Ref}
        toRef={div6Ref}
        duration={3}
      />
      <AnimatedBeam
        containerRef={containerRef}
        fromRef={div2Ref}
        toRef={div6Ref}
        duration={3}
      />
      <AnimatedBeam
        containerRef={containerRef}
        fromRef={div3Ref}
        toRef={div6Ref}
        duration={3}
      />
      <AnimatedBeam
        containerRef={containerRef}
        fromRef={div4Ref}
        toRef={div6Ref}
        duration={3}
      />
      <AnimatedBeam
        containerRef={containerRef}
        fromRef={div5Ref}
        toRef={div6Ref}
        duration={3}
      />
      <AnimatedBeam
        containerRef={containerRef}
        fromRef={div6Ref}
        toRef={div7Ref}
        duration={3}
      />
    </div>
  );
}

const Icons = {
  Notion: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-notion">
          <circle cx="50" cy="50" r="45" />
        </clipPath>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="45"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      <image
        href={driverFive}
        x="0"
        y="0"
        width="100"
        height="100"
        clipPath="url(#clip-notion)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  ),

  Openai: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-openai">
          <circle cx="50" cy="50" r="45" />
        </clipPath>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="45"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      <image
        href={rentidLogo}
        x="0"
        y="0"
        width="100"
        height="100"
        clipPath="url(#clip-openai)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  ),

  GoogleDrive: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-google-drive">
          <circle cx="50" cy="50" r="45" />
        </clipPath>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="45"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      <image
        href={driverOne}
        x="0"
        y="0"
        width="100"
        height="100"
        clipPath="url(#clip-google-drive)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  ),

  Whatsapp: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-whatsapp">
          <circle cx="50" cy="50" r="45" />
        </clipPath>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="45"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      <image
        href={driverTwo}
        x="0"
        y="0"
        width="100"
        height="100"
        clipPath="url(#clip-whatsapp)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  ),

  GoogleDocs: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-google-docs">
          <circle cx="50" cy="50" r="45" />
        </clipPath>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="45"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      <image
        href={driverThree}
        x="0"
        y="0"
        width="100"
        height="100"
        clipPath="url(#clip-google-docs)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  ),

  Messenger: () => (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clip-messenger">
          <circle cx="50" cy="50" r="45" />
        </clipPath>
      </defs>

      <circle
        cx="50"
        cy="50"
        r="45"
        fill="white"
        stroke="#e5e7eb"
        strokeWidth="2"
      />

      <image
        href={driverFour}
        x="0"
        y="0"
        width="100"
        height="100"
        clipPath="url(#clip-messenger)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  ),
  User: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <image href={layerPlatform} x="4" y="4" width="16" height="16" />
    </svg>
  ),
};
